import { axiosInstance } from '../axios/axiosConfig';

const baseUrl = '/Lookup';
export const getDayOfWeek = async () => {
    var result = await axiosInstance.get(`${baseUrl}/DaysOfWeek`);
    return result.data;
};
export const getTimeSlot = async () => {
    var result = await axiosInstance.get(`/TimeSlots`);
    return result.data;
};
export const getTrainerCondition = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetTrainerCondition`);
    return result.data;
};

export const getCourseCategories = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetCourseCategories`);
    return result.data;
};

// Consultation dropdowns (CommonItem options with per-language names, display-ordered).
export const getConsultationTimeSlots = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetConsultationTimeSlots`);
    return result.data;
};

export const getConsultationCourseInterests = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetConsultationCourseInterests`);
    return result.data;
};

export const getKoreanLevels = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetKoreanLevels`);
    return result.data;
};

// FAQ categories (CommonItem FAQ_CATEGORY) with per-language names — used to filter FAQ posts.
export const getFaqCategories = async () => {
    var result = await axiosInstance.get(`${baseUrl}/GetFaqCategories`);
    return result.data;
};